import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "min-h-screen",
  "data-theme": "red"
}
const _hoisted_2 = { class: "max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_3 = {
  href: '/news',
  class: "text-sm text-blue-700 hover:text-blue-900 mb-4 inline-block"
}
const _hoisted_4 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8" }
const _hoisted_5 = { class: "flex items-start justify-between gap-3 mb-2" }
const _hoisted_6 = { class: "text-2xl font-bold text-gray-900" }
const _hoisted_7 = {
  key: 0,
  class: "flex gap-2 shrink-0"
}
const _hoisted_8 = ["action"]
const _hoisted_9 = ["value"]
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "text-xs text-gray-500 mb-6" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "text-lg font-semibold text-gray-900 mb-4" }
const _hoisted_15 = { class: "space-y-4 mb-6" }
const _hoisted_16 = { class: "flex items-start gap-3" }
const _hoisted_17 = { class: "inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-sm font-medium text-blue-800 shrink-0 mt-0.5" }
const _hoisted_18 = { class: "flex-1" }
const _hoisted_19 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 1,
  class: "text-sm font-medium text-gray-900"
}
const _hoisted_22 = { class: "text-xs text-gray-400" }
const _hoisted_23 = {
  key: 0,
  class: "mb-1 px-3 py-1.5 bg-gray-50 border-l-2 border-blue-300 rounded text-xs text-gray-500"
}
const _hoisted_24 = { class: "font-medium text-gray-700" }
const _hoisted_25 = { class: "text-sm text-gray-700 whitespace-pre-line" }
const _hoisted_26 = { class: "mt-2 flex gap-2" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  class: "text-center text-gray-400 text-sm mb-6"
}
const _hoisted_29 = {
  key: 1,
  class: "bg-white rounded-xl shadow-sm border border-gray-200 p-4"
}
const _hoisted_30 = {
  key: 0,
  class: "mb-2 px-3 py-1.5 bg-gray-50 border-l-2 border-blue-300 rounded text-xs text-gray-500 flex items-center justify-between"
}
const _hoisted_31 = { class: "font-medium text-gray-700" }
const _hoisted_32 = { class: "flex gap-2 items-center mb-2" }
const _hoisted_33 = ["placeholder"]
const _hoisted_34 = { class: "relative" }
const _hoisted_35 = {
  key: 0,
  class: "absolute bottom-full right-0 mb-1 bg-white border border-gray-200 rounded-lg shadow-lg p-2 z-50 w-64 flex flex-wrap gap-1"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["disabled"]
const _hoisted_38 = {
  key: 2,
  class: "text-center text-sm text-gray-500"
}
const _hoisted_39 = {
  href: "/users/sign_in",
  class: "text-blue-700 hover:underline"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavBar"], {
      "signed-in": $props.signedIn,
      "user-name": $props.userName,
      "active-page": "news"
    }, null, 8 /* PROPS */, ["signed-in", "user-name"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, "← " + _toDisplayString($setup.t('news.back_to_list')), 1 /* TEXT */),
      _createCommentVNode(" Article "),
      _createElementVNode("article", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h1", _hoisted_6, _toDisplayString($props.newsItem.title), 1 /* TEXT */),
          ($props.userAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("form", {
                  action: `/news/${$props.newsItem.id}/share_telegram`,
                  method: "post",
                  class: "inline"
                }, [
                  _createElementVNode("input", {
                    type: "hidden",
                    name: "authenticity_token",
                    value: $props.csrfToken
                  }, null, 8 /* PROPS */, _hoisted_9),
                  _cache[3] || (_cache[3] = _createElementVNode("button", {
                    type: "submit",
                    class: "px-3 py-1.5 text-xs font-medium text-white bg-[#2AABEE] rounded-lg hover:bg-[#229ED9] transition inline-flex items-center gap-1"
                  }, [
                    _createElementVNode("svg", {
                      class: "w-3.5 h-3.5",
                      viewBox: "0 0 24 24",
                      fill: "currentColor"
                    }, [
                      _createElementVNode("path", { d: "M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0zm5.94 8.13l-1.97 9.28c-.15.67-.54.83-1.09.52l-3.02-2.22-1.46 1.4c-.16.16-.3.3-.61.3l.22-3.06 5.57-5.03c.24-.22-.05-.33-.38-.13l-6.88 4.33-2.97-.93c-.64-.2-.66-.64.14-.95l11.6-4.47c.54-.2 1.01.13.83.95z" })
                    ]),
                    _createTextVNode(" Telegram ")
                  ], -1 /* CACHED */))
                ], 8 /* PROPS */, _hoisted_8),
                _createElementVNode("a", {
                  href: `/news/${$props.newsItem.id}/edit`,
                  class: "px-3 py-1.5 text-xs font-medium text-blue-700 bg-blue-50 rounded-lg hover:bg-blue-100 transition"
                }, _toDisplayString($setup.t('news.edit')), 9 /* TEXT, PROPS */, _hoisted_10),
                _createElementVNode("button", {
                  onClick: $setup.deleteNews,
                  class: "px-3 py-1.5 text-xs font-medium text-red-700 bg-red-50 rounded-lg hover:bg-red-100 transition"
                }, _toDisplayString($setup.t('news.delete')), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("p", _hoisted_11, _toDisplayString($props.newsItem.user.name) + " · " + _toDisplayString($setup.formatDate($props.newsItem.created_at)), 1 /* TEXT */),
        _createElementVNode("div", {
          class: "text-gray-700 leading-relaxed news-content",
          innerHTML: $setup.bodyForDisplay
        }, null, 8 /* PROPS */, _hoisted_12),
        ($props.newsItem.forum_topic_id)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: `/forum/${$props.newsItem.forum_topic_id}`,
              class: "mt-4 inline-block text-sm text-blue-700 hover:underline"
            }, _toDisplayString($setup.t('news.discuss_in_forum')) + " →", 9 /* TEXT, PROPS */, _hoisted_13))
          : _createCommentVNode("v-if", true)
      ]),
      _createCommentVNode(" Comments "),
      _createElementVNode("h3", _hoisted_14, _toDisplayString($setup.t('news.comments')) + " (" + _toDisplayString($setup.comments.length) + ")", 1 /* TEXT */),
      _createElementVNode("div", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.comments, (msg) => {
          return (_openBlock(), _createElementBlock("div", {
            key: msg.id,
            class: "bg-white rounded-xl shadow-sm border border-gray-200 p-4"
          }, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(msg.user.name.charAt(0).toUpperCase()), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  ($props.signedIn && msg.user.id !== $props.userId)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: $event => ($setup.openChatWith(msg.user)),
                        class: "text-sm font-medium text-gray-900 hover:text-blue-700 cursor-pointer"
                      }, _toDisplayString(msg.user.name), 9 /* TEXT, PROPS */, _hoisted_20))
                    : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(msg.user.name), 1 /* TEXT */)),
                  _createElementVNode("span", _hoisted_22, _toDisplayString($setup.formatDateTime(msg.created_at)), 1 /* TEXT */)
                ]),
                (msg.parent_preview)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, _toDisplayString(msg.parent_preview.user_name), 1 /* TEXT */),
                      _createTextVNode(": " + _toDisplayString(msg.parent_preview.body), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("p", _hoisted_25, _toDisplayString(msg.body), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_26, [
                  ($props.signedIn)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: $event => ($setup.startReply(msg)),
                        class: "text-xs text-blue-600 hover:text-blue-800"
                      }, _toDisplayString($setup.t('news.reply')), 9 /* TEXT, PROPS */, _hoisted_27))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      ($setup.comments.length === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString($setup.t('news.no_comments')), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Add comment "),
      ($props.signedIn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            ($setup.replyTo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_31, _toDisplayString($setup.replyTo.user.name), 1 /* TEXT */),
                    _createTextVNode(": " + _toDisplayString($setup.replyTo.body.substring(0, 80)), 1 /* TEXT */)
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = $event => ($setup.replyTo = null)),
                    class: "text-gray-400 hover:text-gray-600 ml-2"
                  }, "×")
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("form", {
              onSubmit: _withModifiers($setup.addComment, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_32, [
                _withDirectives(_createElementVNode("input", {
                  ref: "commentInput",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.newComment) = $event)),
                  type: "text",
                  placeholder: $setup.replyTo ? $setup.t('news.reply_placeholder') : $setup.t('news.comment_placeholder'),
                  required: "",
                  class: "flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                }, null, 8 /* PROPS */, _hoisted_33), [
                  [_vModelText, $setup.newComment]
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = $event => ($setup.showEmojis = !$setup.showEmojis)),
                    class: "text-gray-400 hover:text-gray-600 text-xl p-1"
                  }, "😊"),
                  ($setup.showEmojis)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.emojis, (e) => {
                          return _createElementVNode("button", {
                            key: e,
                            type: "button",
                            onClick: $event => ($setup.addEmoji(e)),
                            class: "text-xl hover:bg-gray-100 rounded p-1 cursor-pointer"
                          }, _toDisplayString(e), 9 /* TEXT, PROPS */, _hoisted_36)
                        }), 64 /* STABLE_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("button", {
                  type: "submit",
                  disabled: !$setup.newComment.trim(),
                  class: "px-4 py-2 text-sm font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800 transition disabled:opacity-50"
                }, _toDisplayString($setup.t('news.send')), 9 /* TEXT, PROPS */, _hoisted_37)
              ])
            ], 32 /* NEED_HYDRATION */)
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_38, [
            _createElementVNode("a", _hoisted_39, _toDisplayString($setup.t('auth.sign_in')), 1 /* TEXT */),
            _createTextVNode(" " + _toDisplayString($setup.t('news.to_comment')), 1 /* TEXT */)
          ]))
    ])
  ]))
}